export const CHECKBOX_RADIO_BUTTON_SETTINGS_SIDEBAR = {
    CHECK_BOX_SETTINGS_TITLE: {
        key: 'CHECK_BOX_SETTINGS_TITLE',
        value: 'CheckBox Settings'
    },
    RADIO_BUTTON_SETTINGS_TITLE: {
        key: 'RADIO_BUTTON_SETTINGS_TITLE',
        value: 'Radio Button Settings'
    },
    CHECK_BOX_GROUP_SETTINGS_TITLE: {
        key: 'CHECK_BOX_GROUP_SETTINGS_TITLE',
        value: 'Checkbox Group Settings'
    },
    RADIO_BUTTON_GROUP_SETTINGS_TITLE: {
        key: 'RADIO_BUTTON_GROUP_SETTINGS_TITLE',
        value: 'Radiobutton Group Settings'
    },
    FIELD_NAME_LABEL: {
        key: 'FIELD_NAME_LABEL',
        value: 'Field name'
    },
    FIELD_NAME_PLACEHOLDER: {
        key: 'FIELD_NAME_PLACEHOLDER',
        value: 'Enter the field name'
    },
    IS_DYNAMIC_LABEL: {
        key: 'IS_DYNAMIC_LABEL',
        value: 'Is Dynamic'
    },
    IS_VALUE_DYNAMIC_LABEL: {
        key: 'IS_VALUE_DYNAMIC_LABEL',
        value: 'Is the value Dynamic '
    },
    DYNAMIC_VALUE_LABEL: {
        key: 'DYNAMIC_VALUE_LABEL',
        value: 'Label'
    },
    DYNAMIC_VALUE_CHECKBOX_LABEL: {
        key: 'DYNAMIC_VALUE_CHECKBOX_LABEL',
        value: 'CheckBox'
    },
    DYNAMIC_VALUE_YES_SWITCH: {
        key: 'DYNAMIC_VALUE_YES_SWITCH',
        value: 'Yes'
    },
    DYNAMIC_VALUE_NO_SWITCH: {
        key: 'DYNAMIC_VALUE_NO_SWITCH',
        value: 'No'
    },
    READ_ONLY_YES_SWITCH: {
        key: 'READ_ONLY_YES_SWITCH',
        value: 'Yes'
    },
    READ_ONLY_NO_SWITCH: {
        key: 'READ_ONLY_NO_SWITCH',
        value: 'No'
    },
    DYNAMIC_LABEL_YES_SWITCH: {
        key: 'DYNAMIC_LABEL_YES_SWITCH',
        value: 'Yes'
    },
    DYNAMIC_LABEL_NO_SWITCH: {
        key: 'DYNAMIC_LABEL_NO_SWITCH',
        value: 'No'
    },
    CHECK_STYLE_LABEL: {
        key: 'CHECK_STYLE_LABEL',
        value: 'Check Style'
    },
    READ_ONLY_LABEL: {
        key: 'READ_ONLY',
        value: 'Read Only'
    },
    DIRECTION_LABEL: {
        key: 'DIRECTION_LABEL',
        value: 'Direction'
    },
    DIRECTION_VERTICAL_VALUE: {
        key: 'DIRECTION_VERTICAL_VALUE',
        value: 'Vertical'
    },
    DIRECTION_HORIZONTAL_VALUE: {
        key: 'DIRECTION_HORIZONTAL_VALUE',
        value: 'Horizontal'
    },
    DYNAMIC_VARIABLE_NAME_LABEL: {
        key: 'DYNAMIC_VARIABLE_NAME_LABEL',
        value: 'Dynamic variable name '
    },
    DYNAMIC_VARIABLE_PLACEHOLDER: {
        key: 'DYNAMIC_VARIABLE_PLACEHOLDER',
        value: '"Enter the name for the dynamic variable"'
    },
    FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE: {
        key: 'FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE',
        value: 'Field name cannot contain any special characters or spaces other than hyphen(-)'
    },
    FIELD_NAME_EXISTS_ERROR_MESSAGE: {
        key: 'FIELD_NAME_EXISTS_ERROR_MESSAGE',
        value: 'Enter a unique field name. {{fieldName}} field name already exists!'
    },
    VARIABLE_SELECT_PLACEHOLDER: {
        key: 'VARIABLE_SELECT_PLACEHOLDER',
        value: 'Select a variable'
    },
    ADD_RADIO_BUTTON_TOOLTIP: {
        key: 'ADD_RADIO_BUTTON_TOOLTIP',
        value: 'add RadioButton',
    },
    ADD_CHECKBOX_TOOLTIP: {
      key: 'ADD_CHECKBOX_TOOLTIP',
      value: 'add checkBox',
    },
    GROUP_NAME_LABEL: {
        key: 'GROUP_NAME_LABEL',
        value: 'Group name'
    },
    GROUP_NAME_PLACEHOLDER: {
        key: 'GROUP_NAME_PLACEHOLDER',
        value: 'Enter the group name'
    }, // TODO : Add note for the need for providing a group name
    ADD_VARIABLE: {
      key: "ADD_VARIABLE",
      value: "Add variable as value"
    },
    ADD_MORE_CHECKBOX: {
      key: "ADD_MORE_CHECKBOX",
      value: "Add more checkbox"
    },
    ADD_MORE_RADIOBUTTON: {
        key: "ADD_MORE_RADIOBUTTON",
        value: "Add more radio button"
      },
    IS_VARIABLE_LABEL: {
      key: 'IS_VARIABLE_LABEL',
      value: 'do you want to set the default value dynamically?'
    },
    OK_LABEL: {
      key: 'OK_LABEL',
      value: 'Ok'
    },
    CANCEL_LABEL: {
      key: 'CANCEL_LABEL',
      value: 'Cancel'
    },
    CHECKED_LABEL: {
        key: 'CHECKED_LABEL',
        value: 'Checked'
    },
    WIDTH_HEIGHT_LABEL: {
        key: 'WIDTH_HEIGHT_LABEL',
        value: 'Width / Height'
    },
    TEXT_SETTINGS_LABEL: {
        key: 'TEXT_SETTINGS_LABEL',
        value: 'Text settings'
    },
};